import React, { Component } from 'react';
import BillingCheckout from './Premium/BillingCheckout';
import BillingSubscribe from './Premium/BillingSubscribe';
import { Button } from 'react-bootstrap';
export default class BillingManager extends Component {
    static displayName = BillingManager.name;
    _isMounted = false;
    constructor(props) {
        super(props);
   
        this.state = {
            hasPaymentMethod: false, message: "", 
            //billingcontainer: (<div className="fa-3x">
            //    <h6 className='text-center' ><i className="fas fa-spinner fa-pulse"></i>  Please wait while billing info loads</h6>
            //</div>),
            billingcontainer: "",
            pmID: ""
           
        }
    }
    checkPM = async () => {     

        if (this.state.pmID === "" && !this.state.hasPaymentMethod) {
            const billResp = await fetch('api/billing/checkcustomer', {
                method: 'GET',
                credentials: 'same-origin'
            });
            if (billResp.status === 200){
                try {
                    const jdata = await billResp.json();

                    if (this._isMounted) {
                        let pmIDchk = jdata.defaultPaymentMethodId;
                        let msg = jdata.message + (!!!pmIDchk ? "Please setup a Payment Method" : "")
                        await this.setState({ message: msg, hasPaymentMethod: !!pmIDchk, pmID: pmIDchk },
                            () => { this.setLandingPage() });
                    }

                } catch (e) {

                    console.log(billResp.statusText);
                    this.setState({ message: '500: Check console' })
                }
            }
            else if (billResp.status === 401) {
                this.setState({ message: '401: Not Authorized' })
            }
            else {

                this.setState({ message: 'There was a problem, please try again later' })
            }
        }
        else { this.setLandingPage()}
       
    }
 
    async componentDidMount() {
        this._isMounted = true;       
        this.props.showBusy(true);
        await ( async () => {
            this.checkPM()
        })();
      
    } 
   

    billingSubEnd = async (failedSubArr) => {
        console.log(failedSubArr+"in billingSubEnd");
        let message = "";
        if (failedSubArr !== null) {
            message = (<div className="row"> <div className="alert alert-danger col"> Charge for Subscription {failedSubArr[0].metadata["teamname"]} failed so we stopped. Error: </div> <div className="col"> {failedSubArr[1].message}</div> </div>);
        }
        this.setState({ message: message });
        await this.setState({ billingcontainer: "" });
        this.setState({
            billingcontainer: <BillingSubscribe message="" billingSubEnd={this.billingSubEnd}  {...this.props} cancel={ this.checkPM}/>
        }); 
    }
    //Pay method successfully setup or change
    paymentSetupSuccess = async (msg) => {
        await (async () => {
            this.checkPM()
        })();
    }

    changePayment = () =>{
        this.setState({
            billingcontainer: <BillingCheckout success={this.paymentSetupSuccess} hasPayment={this.state.hasPaymentMethod} pmID={this.state.pmID} {...this.props}/>}); 
    }
    manageTeamBilling = () => {
        this.setState({
            billingcontainer: < BillingSubscribe message="" billingSubEnd={this.billingSubEnd} {...this.props} cancel={this.checkPM}/>
               
        });
    }

    setLandingPage = () => {
        this.setState({
            billingcontainer: (
               
                <div className="row">
                    <div className="col-sm-6">
                        <div className="card">
                            <h5 className="card-header">Teams</h5>
                            <div className="card-body">
                                <p className="card-text">View which teams you are paying for, and add or remove </p>
                                <button disabled={!this.state.hasPaymentMethod} onClick={this.manageTeamBilling} className="btn btn-secondary">Billing By Team </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card">
                            <h5 className="card-header">Payments</h5>
                            <div className="card-body">
                                <p className="card-text">Setup or Change Payment Method</p>

                                <button onClick={this.changePayment} className="btn btn-secondary">Manage Payment</button>
                            </div>
                        </div>
                    </div>
                </div> 
            )

        }, () => { this.props.showBusy(false);})
    }
    render() {
    
        const billingContainer = this.state.billingcontainer;
       
        //const billingContainer = null;

        const msg = this.state.message ;
        return (
            <div className="container-fluid">  
              
                {/* <div className="text-danger">
                    NOTE:Billing is currently in Stripe <a href="https://stripe.com/docs/testing#cards" target="blank" className="text-info">test mode </a>
                     and will only accept test cards.
                    </div>*/}
                {billingContainer}
                <p>{msg}</p>
            </div>
         
        );
    }
}
